import EncryptedStorage from '$tablet-app/src/app/utils/encryptedStorage';
interface Params {
  // ID of the user
  profile_id: string;
}

/** Locks the app as a given user */
export const setAppIsLocked = async ({ profile_id }: Params): Promise<void> => {
  await EncryptedStorage.setItem(`app-locked`, profile_id);
};
